import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/sign",
    name: "sign",
    component: () => import("../views/Common/Sign.vue"),
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("../views/Common/Forget.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Common/Login.vue"),
  },
  {
    path: "/center",
    name: "center",
    component: () => import("../views/Common/Center.vue"),
  },
  {
    path: "/dingdan",
    name: "dingdan",
    component: () => import("../views/Common/Dingdan.vue"),
  },
  {
    path: "/ruzhu",
    name: "ruzhu",
    component: () => import("../views/Common/Ruzhu.vue"),
  },
  {
    path: "/service-zhuqi",
    name: "service-zhuqi",
    component: () => import("../views/Service/Service-zhuqi.vue"),
  },

  {
    path: "/service-zqdetail",
    name: "service-zqdetail",
    component: () => import("../views/Service/Service-zqdetail.vue"),
  },
  {
    path: "/service-qiye",
    name: "service-qiye",
    component: () => import("../views/Service/Service-qiye.vue"),
  },
  {
    path: "/gongye",
    name: "gongye",
    component: () => import("../views/Gongye/Gongye.vue"),
  },
  {
    path: "/supply",
    name: "supply",
    component: () => import("../views/Supply/Supply.vue"),
    redirect: "/supply-items",
    children: [
      {
        path: "/supply-items",
        name: "supply-items",
        component: () => import("../views/Supply/Supply-items.vue"),
      },
      {
        path: "/supply-detail",
        name: "supply-detail",
        component: () => import("../views/Supply/Supply-detail.vue"),
      },
    ],
  },
  {
    path: "/service",
    name: "service",
    component: () => import("../views/Service/Service.vue"),
    redirect: "/service-items",
    children: [
      {
        path: "/service-items",
        name: "service-items",
        component: () => import("../views/Service/Service-items.vue"),
      },
      {
        path: "/service-detail",
        name: "service-detail",
        component: () => import("../views/Service/Service-detail.vue"),
      },
    ],
  },
  {
    path: "/industry",
    name: "industry",
    component: () => import("../views/Industry/Industry.vue"),
    redirect: "/industry-shops",
    children: [
      {
        path: "/industry-shops",
        name: "industry-shops",
        component: () => import("../views/Industry/Industry-shops.vue"),
      },
      {
        path: "/industry-detail",
        name: "industry-detail",
        component: () => import("../views/Industry/Industry-detail.vue"),
      },
    ],
  },
  {
    path: "/yingyong",
    name: "yingyong",
    component: () => import("../views/Yingyong/Yingyong.vue"),
    redirect: "/yingyong-shops",
    children: [
      {
        path: "/yingyong-shops",
        name: "yingyong-shops",
        component: () => import("../views/Yingyong/Yingyong-shops.vue"),
      },
      {
        path: "/yingyong-detail",
        name: "yingyong-detail",
        component: () => import("../views/Yingyong/Yingyong-detail.vue"),
      },
    ],
  },
  {
    path: "/yiqiyibiao",
    name: "yiqiyibiao",
    component: () => import("../views/Yiqiyibiao/Yiqiyibiao.vue"),
    redirect: "/yiqiyibiao-shops",
    children: [
      {
        path: "/yiqiyibiao-shops",
        name: "yiqiyibiao-shops",
        component: () => import("../views/Yiqiyibiao/Yiqiyibiao-shops.vue"),
      },
      {
        path: "/yiqiyibiao-detail",
        name: "yiqiyibiao-detail",
        component: () => import("../views/Yiqiyibiao/Yiqiyibiao-detail.vue"),
      },
    ],
  },
  {
    path: "/enterprise-list",
    name: "enterprise-list",
    component: () => import("../views/enterprise/list.vue"),
  },
  {
    path: "/enterprise-map",
    name: "enterprise-map",
    component: () => import("../views/enterprise/map.vue"),
  },

  {
    path: "/wanren-link",
    name: "wanren-link",
    component: () => import("../views/Link/wanren.vue"),
  },
];

const router = new VueRouter({
  routes,
});
// 全局钩子当页面跳转自动回到顶部
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  // 将跳转过去的页面的name传参给store
  var Page = { to: to, from: from, next: next };
  store.dispatch("GiveMe", Page);
  next();
});

export default router;
